<a
    #container
    role="menuitem"
    tabindex="0"
    *ngIf="externalEndpoint"
    [title]="appPage.displayName"
    [target]="appPage.newTab ? '_blank' : '_self'"
    [href]="externalEndpoint ? appPage.navigationTo : baseUrl + appPage.navigationTo">
    <ng-container *ngTemplateOutlet="content"></ng-container>
</a>
<a
    #container
    role="menuitem"
    tabindex="0"
    *ngIf="!externalEndpoint"
    [title]="appPage.displayName"
    [routerLink]="externalEndpoint ? null : [appPage.navigationTo]"
    [queryParams]="externalEndpoint ? null : appPage.navigationQuery">
    <ng-container *ngTemplateOutlet="content"></ng-container>
</a>
<ng-template #content>
    <img class="icon" [src]="appPage.iconPath" [alt]="appPage.displayName" />

    <div class="text-container">
        <div class="text" [ngStyle]="{ 'transition-delay': index * 0.02 + 's' }">
            {{ appPage.displayTitleLabelPath | labelsProvider }}
        </div>
    </div>
</ng-template>
